import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi)  // load translations from files or API
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass i18n to react-i18next
  .init({
    fallbackLng: 'jp',
    supportedLngs: ['en', 'jp'],
    nonExplicitSupportedLngs: true,
    debug: false,
    detection: {
      convertDetectedLanguage: (lng) => (
        String(lng || '').toLowerCase().startsWith('ja') ? 'jp' : lng
      ),
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
